import React from 'react';
import EventCard from 'components/molecules/event-card/EventCard';

function HightowerDisappear() {
  const dateTexts = ['1899年', '12月', '31日'];
  const title = 'ハイタワー三世失踪';
  const imgUrl = 'https://seadictionary.disneyparkstory.com/wp-content/uploads/sites/2/2021/12/CIMG2265.jpg'
  const description = (
    <>
      {'12月31日、'}
      <a href='/harrison-hightower-iii'>
        {'ハイタワー三世'}
      </a>
      {'の帰還を祝した祝賀パーティ＆ニューイヤーパーティがホテルハイタワーで開催される。'}
      {'その夜、彼の乗ったエレベーターが落下し、彼は行方不明となる。'}
    </>
  );

  return (
    <EventCard
      dateTexts={dateTexts}
      title={title}
      description={description}
      imgUrl={imgUrl}
    />
  );
}

export default HightowerDisappear;
